// ABOUTME: Lightning bolt badge icon with gradient on gray background
// ABOUTME: Used for dynamic/automated feature indicators in headers

interface IconProps {
  className?: string
  size?: number
}

export const LightningBadgeIcon = ({ className = "", size = 17 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      width="16.4033"
      height="16.4033"
      rx="8"
      fill="#F5F6F6"
    />
    <g clipPath="url(#clip0_lightning_badge)">
      <path
        d="M12.0515 8.42589L7.45853 13.3469C7.40986 13.3988 7.34562 13.4335 7.27549 13.4458C7.20536 13.458 7.13316 13.4471 7.06979 13.4147C7.00641 13.3823 6.95529 13.3301 6.92414 13.2661C6.893 13.2021 6.88352 13.1297 6.89713 13.0598L7.49831 10.0527L5.135 9.16527C5.08425 9.14629 5.03899 9.11503 5.00326 9.07428C4.96754 9.03353 4.94246 8.98457 4.93028 8.93177C4.91809 8.87897 4.91918 8.82397 4.93343 8.77169C4.94769 8.71941 4.97468 8.67147 5.01198 8.63217L9.60491 3.71117C9.65358 3.65923 9.71783 3.62452 9.78795 3.6123C9.85808 3.60007 9.93028 3.61099 9.99366 3.64339C10.057 3.6758 10.1082 3.72794 10.1393 3.79195C10.1704 3.85596 10.1799 3.92836 10.1663 3.99823L9.56349 7.00865L11.9268 7.89484C11.9772 7.91395 12.0221 7.94518 12.0575 7.98576C12.093 8.02635 12.1179 8.07504 12.13 8.12753C12.1422 8.18003 12.1412 8.23471 12.1273 8.28675C12.1133 8.33878 12.0867 8.38657 12.0498 8.42589H12.0515Z"
        fill="url(#paint0_linear_lightning_badge)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_lightning_badge"
        x1="4.92188"
        y1="8.52903"
        x2="12.1385"
        y2="8.52903"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#66B6FF" />
        <stop
          offset="1"
          stopColor="#93D8FF"
        />
      </linearGradient>
      <clipPath id="clip0_lightning_badge">
        <rect
          width="10.4981"
          height="10.4981"
          fill="white"
          transform="translate(3.28125 3.28125)"
        />
      </clipPath>
    </defs>
  </svg>
)
